export const isVerifyEmailCodeSuccess = (
  response: boolean | { success?: boolean } | null,
): boolean => (typeof response === 'boolean' ? response : Boolean(response?.success));
